import { isTokenExpired } from "../services/authServices";

export const isAuthenticated = (): boolean => {
  const token = localStorage.getItem("token");
  const refreshToken = localStorage.getItem("refreshToken");

  // If both tokens are missing, user is not authenticated
  if (!token && !refreshToken) {
    return false;
  }

  // If token exists but is expired, check if we have a refresh token
  if (token && isTokenExpired(token)) {
    // If we have a refresh token, consider authenticated (will be refreshed)
    // If no refresh token, consider not authenticated
    return !!refreshToken;
  }

  // If token exists and is not expired, user is authenticated
  return !!token;
};
